'use strict';

var EditFailoverPolicyControl = require('actionGroups/failoverPolicyControl/FailoverPolicyControl');

module.exports = {
  Model: EditFailoverPolicyControl,
};
